module.exports = __webpack_public_path__ + "img/定制.93876142.jpg";